module.exports = __webpack_public_path__ + "img/46.006b0d90.svg";